import React 						from 'react';
import DataList 					from './DataTables/DataList.react';
import moment 						from 'moment';
import GoogleSearchCell 			from './DataTables/GoogleSearchCell.react';
import DateCell 					from './DataTables/DateCell.react';
import RemoveFromPileCheckbox 		from './RemoveFromPileCheckbox.react';

/**
 * This file provided by Facebook is for non-commercial testing and evaluation
 * purposes only. Facebook reserves all rights not expressly granted.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL
 * FACEBOOK BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
 * ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

"use strict";

import FixedDataTable from 'fixed-data-table';

const {Table, Column, Cell} = FixedDataTable;

const TextCell = ({rowIndex, data, col, ...props}) => (

  	<Cell {...props}>
    	{data.getObjectAt(rowIndex)[col]}
  	</Cell>
);

class DataListWrapper {

	constructor( indexMap, data ) {

		this._indexMap  = indexMap;
		this._data 		= data;
		this.data 		= data.data;
	}

	getSize() {

		return this._indexMap.length;
	}

	getCollection() {

		return this._data;
	}

	getObjectAt( index ) {

		return this._data.getObjectAt(

			this._indexMap[index],
		);
	}
}

const SortTypes = {

  	ASC 	: 'ASC',
  	DESC 	: 'DESC',
};

function reverseSortDirection(sortDir) {
  return sortDir === SortTypes.DESC ? SortTypes.ASC : SortTypes.DESC;
}

const iconStyle = {

	height : 15, width : 15, color : '#ff4081'
}


class SortHeaderCell extends React.Component {
	
	constructor(props) {
	
		super(props);

		this._onSortChange = this._onSortChange.bind( this );
	}

	render() {
		
		var {onSortChange, sortDir, children, ...props} = this.props;

		return (
	  		<Cell {...props}>
	    		<a onClick={this._onSortChange}>
	      			{children} {sortDir ? (sortDir === SortTypes.DESC ? '↓' : '↑') : ''}
	    		</a>
	  		</Cell>
		);
	}

	_onSortChange(e) {
		
		e.preventDefault();

		if( this.props.onSortChange ) {

			let newSortDir = ( this.props.sortDir === "DESC" ) ? "ASC" : "DESC";

	  		this.props.onSortChange(

	   			this.props.columnKey,
	    		newSortDir
	  		);
		}
	}
}

function sortReverseInt( a,b ) {

	return parseInt( b ) - parseInt( a );
}

function sortNumber( a,b ) {
    return parseInt( a ) - parseInt( b );
}


class PileCheckDataTable extends React.Component {
	
	constructor( props ) {
		
		super( props );

		this._dataList = new DataList( props.data );

		this._defaultSortIndexes = [];
    	let size = this._dataList.getSize();
    	
    	for (var index = 0; index < size; index++) {
      		
      		this._defaultSortIndexes.push( index );
    	}

		this.state = {
				
			colSortDirs 		: 	{

			},
			checked 		 				: 	props.checked,
			filteredDataList 				: 	this._dataList,
			sortedDataList 					: 	this._dataList
		};

   		this._onSortChange 		= this._onSortChange.bind(this);
		this._onFilterChange 	= this._onFilterChange.bind(this);
	}

	componentWillReceiveProps( newProps ) {

		this._dataList = new DataList( newProps.data );
		this._defaultSortIndexes = [];

    	let size = this._dataList.getSize();
    	
    	for (var index = 0; index < size; index++) {
      		
      		this._defaultSortIndexes.push( index );
    	}

		let sortIndexes 		= this._defaultSortIndexes.slice();
		let sortedDataList 		= new DataListWrapper( sortIndexes, this._dataList );

		
		sortedDataList 	= new DataListWrapper( sortIndexes, this._dataList );

		this.setState({
				
			colSortDirs 		: 	{

			},
			checked 		 				: 	newProps.checked,
			filteredDataList 				: 	this._dataList,
			sortedDataList 					: 	this._dataList
		});
	}

	componentDidMount() {

		
	}

	_onSortChange( columnKey, sortDir ) {
			
		var sortIndexes = this._defaultSortIndexes.slice();

		let sortVal 	= 0;

		if( columnKey === "created_at" ) {

			sortIndexes.sort( ( indexA, indexB ) => {
				
				let valueA 		= this._dataList.getObjectAt(indexA)[columnKey];
				let valueB 		= this._dataList.getObjectAt(indexB)[columnKey];

				const datea 	= moment( valueA );
				const dateb 	= moment( valueB );


				if( datea.isAfter( dateb ) ) {

					sortVal = 1;
				}

				if( datea.isBefore( dateb ) ) {

					sortVal = -1;
				}

				if (sortVal !== 0 && sortDir === SortTypes.ASC ) {
					
					sortVal = sortVal * -1;
				}

				return sortVal;
			});

		} else {

			sortIndexes.sort( ( indexA, indexB ) => {
				
				var valueA = this._dataList.getObjectAt(indexA)[columnKey];
				var valueB = this._dataList.getObjectAt(indexB)[columnKey];

				if (valueA > valueB) {
					sortVal = 1;
				}
				if (valueA < valueB) {
					sortVal = -1;
				}
				if (sortVal !== 0 && sortDir === SortTypes.ASC ) {
					sortVal = sortVal * -1;
				}

				return sortVal;
			});
		}

		let sortedDataList 	= new DataListWrapper( sortIndexes, this._dataList );

		this.setState({
				
			sortedDataList 	: 	sortedDataList,
			colSortDirs 	: 	{

				[columnKey] 	: sortDir,
			},
		});
	}

	_onFilterChange( e ) {
	
		if ( !e.target.value ) {

			this.setState({
				sortedDataList 	: this._dataList
			});
		}
	}

	render() {

		var {sortedDataList, colSortDirs} = this.state;

		return (

			<Table
				rowHeight={30}
				rowsCount={sortedDataList.getSize()}
				headerHeight={30}
				width={1100}
				height={650}
				{...this.props}>


				<Column
					header={<Cell>Name</Cell>}
					cell={<GoogleSearchCell data={sortedDataList} col="name" />}
					width={400}
				/>	

				<Column
					header={<Cell>Hostname</Cell>}
					cell={<GoogleSearchCell data={sortedDataList} col="hostname" />}
					width={450}
				/>	
				
				<Column
					header={<Cell>Created Date</Cell>}
					cell={<DateCell data={sortedDataList} col="created_at" />}
					width={150}
				/>		

				<Column
					header={<Cell>Remove</Cell>}
					cell={<RemoveFromPileCheckbox checked={this.state.checked} data={sortedDataList} col="id" />}
					width={100}
				/>			
			</Table>
		);


	}
}

export default PileCheckDataTable;


// WEBPACK FOOTER //
// ./resources/assets/js/data-feed/components/PileCheckDataTable.react.js